import { useEffect, useRef } from 'react';
import { refreshAccessTokenMain } from '../services/AuthService';
const MIN_INTERVAL = 4 * 60 * 1000;
const MAX_INTERVAL = 6 * 60 * 1000;
const getRandomInterval = () => {
  return Math.floor(Math.random() * (MAX_INTERVAL - MIN_INTERVAL + 1)) + MIN_INTERVAL;
};

export const useRandomTokenRefresh = () => {
  const timeoutRef = useRef(null);
  useEffect(() => {
    const handleLogout = () => {
      localStorage.clear();
      window.location.href = '/login';
    };
    const scheduleRefresh = () => {
      const randomInterval = getRandomInterval();
      timeoutRef.current = setTimeout(async () => {
        const tokenDetails = JSON.parse(localStorage.getItem('userDetails'));
        if (!tokenDetails || !tokenDetails.expireDate) {
          handleLogout();
          return;
        }
        const expireDate = new Date(tokenDetails.expireDate);
        const todaysDate = new Date();
        if (todaysDate > expireDate) {
          handleLogout();
          return;
        }
        await refreshAccessTokenMain();
        scheduleRefresh();
      }, randomInterval);
    };
    scheduleRefresh();
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);
};
